import moment from 'moment';
import statesArray from '../../../app/utils/statesArray';
import projectRequirementsArray from '../../../app/utils/projectRequirementsArray';

const limitsRequestedOptions = [
    { optionId: "1", text: "Select", value: "" },
    { optionId: "2", text: "1m/2m", value: "12" },
    { optionId: "3", text: "2m/2m", value: "22" },
    { optionId: "4", text: "2m/4m", value: "24" },
    { optionId: "5", text: "3m/3m", value: "33" },
    { optionId: "6", text: "4m/4m", value: "44" },
    { optionId: "7", text: "5m/5m", value: "55" },
];


const ocpData = {
    questionSetId: 'OCPFORM',
    name: 'OCPFORM',
    questions: [
        {
            questionId: 'label1',
            inputType: 'label',
            text: 'General Information',
            name: 'label1'
        },
        {
            questionId: '1',
            text: 'Applicant',
            name: 'primaryInsuredName',
            required: true,
            inputType: 'text',
            inputFormat: 'text',
            placeholder: 'This entity must be named as the Owner in the contract receiving hold harmless, indemnification and additional insured status from the hired General Contractor',
            placeholderHidden: false
        },
        {
            questionId: '2',
            name: 'primaryInsuredAddressLabel',
            text: "Mailing Address",
            inputFormat: 'label',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2a',
            name: 'primaryInsuredAddress',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'Address 1',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2aa',
            name: 'primaryInsuredAddress2',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: false,
            placeholder: 'Address Line 2',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '2b',
            name: 'primaryInsuredCity',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '2c',
            name: 'primaryInsuredState',
            inputType: 'dropdown-single',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2d',
            name: 'primaryInsuredZipcode',
            inputType: 'text',
            inputFormat: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2e',
            name: 'primaryInsuredWebsite',
            inputType: 'text',
            inputFormat: 'text',
            tooltiptext: 'Please provide Website.',
            required: false,
            placeholder: 'Website',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: 'label6',
            inputType: 'label',
            text: 'Project Details',
            name: 'label6'
        },
        {
            questionId: '22',
            name: 'projectName',
            text: 'Project Name?',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
        },
        {
            questionId: '10',
            name: 'nameInsuredAddressLabel',
            text: 'What is the address of the project?',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'projectAddress'
            },
            placeholder: 'This must be a single location, the policy is project specific',
            placeholderExposed: true
        },

        {
            questionId: '10a',
            name: 'projectAddress',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'Address 1',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '10aa',
            name: 'projectAddress2',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: false,
            placeholder: 'Address Line 2',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },

        {
            questionId: '10b',
            name: 'projectCity',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '10c',
            name: 'projectState',
            inputType: 'dropdown-single',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '10d',
            name: 'projectZipcode',
            inputType: 'text',
            inputFormat: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '24',
            name: 'parcelId',
            text: 'Parcel ID',
            inputFormat: 'text',
            inputType: 'freeform',
            subHelper: `Underwriter will confirm clearance shortly`,
            subHelperTitle: `Please note: `,
            required: false,
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '10e',
            name: 'nycha',
            text: 'If Project is in New York, is this a NYC Housing Authority (NYCHA) Project?',
            inputType: 'radio',
            required: false,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '4',
            text: 'Effective date',
            name: 'anticipatedStartDate',
            required: true,
            inputType: 'text',
            inputFormat: 'date',
            helper:
                `Please provide the date as or before ${moment(Date.now()+ 90 * 24 * 60 * 60 * 1000).format('MM/DD/YYYY')} (90 days)`,
            helper_uw:
                `Please provide the date between ${moment(Date.now()- 90 * 24 * 60 * 60 * 1000).format('MM/DD/YYYY')} and ${moment(Date.now()+ 90 * 24 * 60 * 60 * 1000).format('MM/DD/YYYY')} (90 days back and future date)`
        },
        {
            questionId: '5',
            text: 'Finish date',
            name: 'anticipatedFinishDate',
            required: true,
            inputType: 'text',
            inputFormat: 'date',
            helper: 'If this is unknown, then set to one year in advance'
        },
        {
            questionId: '3',
            text: 'What are the total construction costs of this project?',
            name: 'totalCost',
            required: true,
            inputType: 'text',
            inputFormat: 'currency',
            helper: '*This is the exposure the quote will be rated on and is subject to audit.',
            placeholder:
                'Total Construction Value means the total cost of all work let or sublet including: a) the cost of all labor, materials and equipment furnished, used or delivered for use in the execution of the work and b) all fees bonuses or commissions made, paid or due.',
            placeholderHidden: true
        },
        {
            questionId: '29',
            name: 'contractNumber',
            text: 'Contract # (if known)',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
        },
        {
            questionId: '13',
            text: 'Scope of Work',
            name: 'projectScope',
            required: true,
            inputType: 'freeform',
            inputFormat: 'text',
            helper: 'Provide as much detail as possible.',
        },
        {
            questionId: '23',
            name: 'projectType',
            text: 'Project Type?',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Select',
                        value: '',
                    },
                    {
                        optionId: '2',
                        text: 'Industrial',
                        value: 'Industrial'

                    },
                    {
                        optionId: '3',
                        text: 'Residential',
                        value: 'Residential',
                        supplementalquestionIds: ['23_supplemental1']
                    },
                    {
                        optionId: '4',
                        text: 'Commercial',
                        value: 'Commercial'
                    },
                ]
            }

        },
        {
            questionId: '24',
            name: 'constructionSite',
            text: 'New or Remodel/Renovation or Demo only',
            inputType: 'dropdown-single',
            affectOtherField: 'squareFootagePercent',
            thirdLevelSupplementQuesId: ['14_supplemental_2'],
            required: true,
                attributes: {
                    options: [
                        {
                            optionId: '1',
                            text: 'Select',
                            value: ''
                        },
                        {
                            optionId: '2',
                            text: 'New',
                            value: 'New'
                        },
                        {
                            optionId: '3',
                            text: 'Remodel/Renovation',
                            value: 'Remodel/Renovation',
                            supplementalquestionIds: ['14_supplemental_1']
                        },
                        {
                        optionId: '4',
                            text: 'Demo Only',
                            value: 'Demo Only'
                        },
                    ],
                }
        },
        {
            questionId: '50',
            text: 'Total square footage of the finished project',
            name: 'squareFootage',
            required: false,
            inputType: 'text',
            inputFormat: 'text',
            attributes: {
                options: [
                    {
                        supplementalquestionIds: ['50_supplemental_1']
                    },
                ]
            },
        },
        {
            questionId: '57',
            text: 'Number of stories of the finished project',
            name: 'storiesFinishedProject',
            required: false,
            inputType: 'number',
            inputFormat: 'number',
            placeholderHidden: true
        },
        {
            questionId: '51',
            text: 'Is project limited to specific floors?',
            name: 'specificFloors',
            inputType: 'radio',
            tooltiptext: 'Please choose if project is limited to specific floors.',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['51_supplemental_1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ]
            }
        },
        {
            questionId: '330',
            text: 'Does the project include any vertical expansion?',
            name: 'isVerticalExpansion',
            placeholder: 'If this is a Ground Up Construction project, select No.',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['330_supplemental_1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '331',
            text:
                'Does the project include any horizontal expansion?',
            name: 'isHorizontalExpansion',
            inputType: 'radio',
            placeholder: 'If this is a Ground Up Construction project, select No.',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['331_supplemental_1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '18',
            name: 'exteriorWorkFourStories',
            text: 'Is there any exterior work being done over 5 stories?',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '52',
            name: 'eightFeet',
            text: 'Will any work be performed more than eight (8) feet below grade?',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '53',
            text: 'Describe the intended end use of the building?',
            name: 'endUseOfBuilding',
            required: true,
            inputType: 'text',
            inputFormat: 'text',
            placeholderHidden: true
        },
        {
            questionId: '15',
            name: 'projectRequirements',
            text:
                'Does the project involve work related to any of the following: ',
            inputType: 'checkbox',
            required: true,
            attributes: {
                options: projectRequirementsArray()
            }
        },
        {
            questionId: '54',
            text: 'Does the project include any form of demolition?',
            name: 'exteriorDemo',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '54_supplemental1',
                            '997_supplemental2',
                            '54_supplemental3',
                            '54_supplemental4',
                            '54_supplemental5',
                            '54_supplemental6',
                            '54_supplemental7',
                            '54_supplemental8',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: 'workStarted',
            text: 'Has work started on this project?',
            name: 'workStarted',
            required: true,
            inputType: 'radio',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '19',
            text: 'Does this project involve a servicing/maintenance contract with several locations?',
            name: 'servicingSeveralLocations',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '17_supplementalA',
                            '17_supplementalB',
                            '17_supplementalC',
                            '17_supplementalD',
                            '17_supplementalE',
                            '17_supplementalF'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },

        {
            questionId: 'label3',
            inputType: 'label',
            text: 'General Contractor',
            name: 'label3'
        },
        {
            questionId: '7',
            text: 'Is the General Contractor known?',
            name: 'generalContractorKnown',
            required: false,
            inputType: 'radio',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '7_supplemental1',
                            '7_supplemental2',
                            '7_supplemental3',
                            '7_supplemental4',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '55',
            text: 'Is there any common ownership between the Owner and the General Contractor?',
            name: 'commonOwnership',
            required: true,
            inputFormat: 'radio',
            inputType: 'radio',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '14',
            name: 'isSupervisingSubs',
            text:
                'Will the named insured be involved with any supervision or oversight of the project?',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },

        {
            questionId: '32',
            name: 'otherSubcontractorsPaid',
            text:
                'Is the owner paying, contracting, or supervising any subcontractors other than GC?',
            inputType: 'radio',
            helper: 'Note our appetite for OCPs is for ONE directly hired contractor. If the owner is hiring more than one contractor directly, this risk is ineligible.',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },

        {
            questionId: 'label4',
            inputType: 'label',
            text: 'Limits Requested',
            name: 'label4'
        },

        {
            questionId: '16',
            name: 'limitsRequested',
            text: 'What limits are being requested for this OCP?',
            inputType: 'dropdown-single',
            required: true,
            helper:
                'If the limits you require is not listed, please select closest desired and provide requested amount in general comments',
            attributes: {
                options: limitsRequestedOptions
            }
        },

        {
            questionId: 'label5',
            inputType: 'label',
            text: 'General Comments',
            name: 'label5'
        },

        {
            questionId: '20',
            name: 'generalComments',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
            helper: 'Please provide any comments or assumptions to question responses'
        },
        {
            questionId: '67',
            name: 'auditorInformation',
            text: 'Audit Contact Information',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '67aa',
            name: 'auditorName',
            inputType: 'text',
            inputFormat: 'label',
            required: false,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '67bb',
            name: 'auditorEmail',
            inputType: 'text',
            inputFormat: 'label',
            required: false,
            placeholder: 'Email',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '67cc',
            name: 'auditorPhone',
            inputType: 'text',
            inputFormat: 'phone',
            required: false,
            placeholder: 'Phone number',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '21',
            name: 'nameInsuredAddressLabel',
            text: 'Contact Information',
            inputFormat: 'label',
            title: 'Please provide your contact info to receive your quote',
            attributes: {
                controlGroup: 'contactInfo'
            }
        },
        {
            questionId: '21a',
            name: 'email',
            inputType: 'text',
            inputFormat: 'label',
            required: true,
            placeholder: 'Email',
            attributes: {
                controlGroup: 'contactInfo'
            }
        },
        {
            questionId: '21b',
            name: 'phone',
            inputType: 'text',
            inputFormat: 'phone',
            required: true,
            placeholder: 'Phone Number',
            attributes: {
                controlGroup: 'contactInfo'
            }
        }
    ],

    supplementalQuestions: [
        {
            questionId: '23_supplemental1',
            name: 'residentials',
            text: 'Total # of units, lots, and or homes',
            inputFormat: 'text',
            inputType: 'freeform',
            tooltiptext: 'Residential',
            required: false
        },
        {
            questionId: '14_supplemental_1',
            name: 'structuralWork',
            text: 'Will there be any structural work performed?',
            inputType: 'radio',
            tooltiptext: 'structuralWork',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '14_supplemental_2',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '14_supplemental_2',
            name: 'StructuralWorkPerformedDetail',
            text: 'Provide all known details.',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
            attributes: {
                controlGroup: 'residential'
            }
        },
        {
            questionId: '50_supplemental_1',
            name: 'squareFootagePercent',
            text: 'If remodel/renovation, advise % of total building square footage that is being renovated',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            placeholderHidden: true,
        },
        {
            questionId: '51_supplemental_1',
            text: 'Please provide details',
            name: 'specificFloorsDetails',
            inputFormat: 'text',
            inputType: 'freeform',
            tooltiptext: 'Please choose if project is limited to specific floors.',
            required: false
        },
        {
            questionId: '54_supplemental1',
            text: 'What is the name of the demolition contractor being hired?',
            name: 'demolitionDetailsContractor',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '997_supplemental2',
            text: 'Who is hiring the demolition contractor, the General Contractor, or the Owner?',
            name: 'demolitionDetailsGCOwner',
            inputType: 'radio',
            inputFormat: 'radio',
            required: true,
            placeholder:
                'Please note that if this information changes, the pricing you receive is no longer valid and the account must be re-rated',
            placeholderExposed: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'General Contractor',
                        value: true,
                    },
                    {
                        optionId: '2',
                        text: 'Owner',
                        value: false,
                    }
                ],
                controlGroup: 'exteriorDemo'
            },
        },
        {
            questionId: '54_supplemental3',
            text: 'Total Demolition Cost',
            name: 'demolitionDetailsCost',
            inputType: 'text',
            inputFormat: 'currency',
            required: true,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '54_supplemental4',
            name: 'demolitionDetailsInterior',
            text: 'Is the demo work being performed interior only?',
            inputType: 'radio',
            inputFormat: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ],
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '54_supplemental5',
            text: 'Total # of stories being demolished?',
            name: 'demolitionDetailsStories',
            inputType: 'text',
            inputFormat: 'number',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '54_supplemental6',
            text: 'Describe methods used for demolition (any use of ball & chain or blasting)?',
            name: 'demolitionDetailsMethod',
            inputType: 'freeform',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '54_supplemental7',
            text: 'How many months will demolition take?',
            name: 'demolitionDetailsMonths',
            inputType: 'text',
            inputFormat: 'number',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '54_supplemental8',
            text: 'Describe the safety precautions in place to protect pedestrians & workers.',
            name: 'demolitionDetailsPrecautions',
            inputType: 'freeform',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '330_supplemental_1',
            text: 'Please provide details.',
            name: 'verticalExpansionDetail',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false
        },
        {
            questionId: '331_supplemental_1',
            text: 'Please provide details.',
            name: 'horizontalExpansionDetail',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false
        },
        {
            questionId: '7_supplemental1',
            text: 'Name of General Contractor',
            name: 'generalContractorName',
            required: false,
            inputType: 'text',
            inputFormat: 'text',
            attributes: {
                controlGroup: 'generalContractorInfo'
            }
        },
        {
            questionId: '7_supplemental2',
            text: 'Who is the GL Carrier of the General Contractor?',
            name: 'generalLiabilityCarrier',
            required: false,
            inputType: 'text',
            inputFormat: 'text',
            attributes: {
                controlGroup: 'generalContractorInfo'
            }
        },
        {
            questionId: '7_supplemental3',
            text: 'What are the total liability limits carried by the General Contractor?',
            name: 'generalContractorAmount',
            helper: 'General Liability plus Excess',
            required: false,
            inputType: 'text',
            inputFormat: 'currency',
            attributes: {
                controlGroup: 'generalContractorInfo'
            }
        },

        {
            questionId: '7_supplemental4',
            text: "Expiration Date of the GC's GL Policy",
            name: 'generalContractorExpirationDate',
            required: false,
            inputType: 'text',
            inputFormat: 'date',
            attributes: {
                controlGroup: 'generalContractorInfo'
            }
        },
        // Additional Site # 1
        {
            questionId: '17_supplementalA',
            name: 'otherSiteLabel1',
            text: 'Additional Site 1:',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'otherSiteDetails1'
            }
        },
        {
            questionId: '17_supplementalB',
            name: 'otherSiteAddress1',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Address',
            attributes: {
                controlGroup: 'otherSiteDetails1'
            }
        },
        {
            questionId: '17_supplementalC',
            name: 'otherSiteCity1',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'otherSiteDetails1'
            }
        },
        {
            questionId: '17_supplementalD',
            name: 'otherSiteState1',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'otherSiteDetails1'
            }
        },
        {
            questionId: '17_supplementalE',
            name: 'otherSiteZipcode1',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Zipcode',
            attributes: {
                controlGroup: 'otherSiteDetails1'
            }
        },
        {
            questionId: '17_supplementalF',
            text: 'Are there any additional Sites?',
            name: 'otherSitesAdditional1',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            attributes: {
                controlGroup: 'otherSiteDetails1',
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '18_supplementalA',
                            '18_supplementalB',
                            '18_supplementalC',
                            '18_supplementalD',
                            '18_supplementalE',
                            '18_supplementalF'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        // Additional Site #2
        {
            questionId: '18_supplementalA',
            name: 'otherSiteLabel2',
            text: 'Additional Site 2:',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'otherSiteDetails2'
            }
        },
        {
            questionId: '18_supplementalB',
            name: 'otherSiteAddress2',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Address',
            attributes: {
                controlGroup: 'otherSiteDetails2'
            }
        },
        {
            questionId: '18_supplementalC',
            name: 'otherSiteCity2',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'otherSiteDetails2'
            }
        },
        {
            questionId: '18_supplementalD',
            name: 'otherSiteState2',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'otherSiteDetails2'
            }
        },
        {
            questionId: '18_supplementalE',
            name: 'otherSiteZipcode2',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Zipcode',
            attributes: {
                controlGroup: 'otherSiteDetails2'
            }
        },
        {
            questionId: '18_supplementalF',
            text: 'Are there any additional Sites?',
            name: 'otherSitesAdditional2',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            attributes: {
                controlGroup: 'otherSiteDetails2',
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '19_supplementalA',
                            '19_supplementalB',
                            '19_supplementalC',
                            '19_supplementalD',
                            '19_supplementalE',
                            '19_supplementalF'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        // Additional Site #3
        {
            questionId: '19_supplementalA',
            name: 'otherSiteLabel3',
            text: 'Additional Site 3:',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'otherSiteDetails3'
            }
        },
        {
            questionId: '19_supplementalB',
            name: 'otherSiteAddress3',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Address',
            attributes: {
                controlGroup: 'otherSiteDetails3'
            }
        },
        {
            questionId: '19_supplementalC',
            name: 'otherSiteCity3',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'otherSiteDetails3'
            }
        },
        {
            questionId: '19_supplementalD',
            name: 'otherSiteState3',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'otherSiteDetails3'
            }
        },
        {
            questionId: '19_supplementalE',
            name: 'otherSiteZipcode3',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Zipcode',
            attributes: {
                controlGroup: 'otherSiteDetails3'
            }
        },
        {
            questionId: '19_supplementalF',
            text: 'Are there any additional Sites?',
            name: 'otherSitesAdditional3',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            attributes: {
                controlGroup: 'otherSiteDetails3',
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '20_supplementalA',
                            '20_supplementalB',
                            '20_supplementalC',
                            '20_supplementalD',
                            '20_supplementalE',
                            '20_supplementalF'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },

        // Additional Site #4
        {
            questionId: '20_supplementalA',
            name: 'otherSiteLabel4',
            text: 'Additional Site 4:',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'otherSiteDetails4'
            }
        },
        {
            questionId: '20_supplementalB',
            name: 'otherSiteAddress4',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Address',
            attributes: {
                controlGroup: 'otherSiteDetails4'
            }
        },
        {
            questionId: '20_supplementalC',
            name: 'otherSiteCity4',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'otherSiteDetails4'
            }
        },
        {
            questionId: '20_supplementalD',
            name: 'otherSiteState4',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'otherSiteDetails4'
            }
        },
        {
            questionId: '20_supplementalE',
            name: 'otherSiteZipcode4',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Zipcode',
            attributes: {
                controlGroup: 'otherSiteDetails4'
            }
        },
        {
            questionId: '20_supplementalF',
            text: 'Are there any additional Sites?',
            name: 'otherSitesAdditional4',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            attributes: {
                controlGroup: 'otherSiteDetails4',
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '21_supplementalA',
                            '21_supplementalB',
                            '21_supplementalC',
                            '21_supplementalD',
                            '21_supplementalE',
                            '21_supplementalF'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        // Additional Site #5
        {
            questionId: '21_supplementalA',
            name: 'otherSiteLabel5',
            text: 'Additional Site 5:',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'otherSiteDetails5'
            }
        },
        {
            questionId: '21_supplementalB',
            name: 'otherSiteAddress5',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Address',
            attributes: {
                controlGroup: 'otherSiteDetails5'
            }
        },
        {
            questionId: '21_supplementalC',
            name: 'otherSiteCity5',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'otherSiteDetails5'
            }
        },
        {
            questionId: '21_supplementalD',
            name: 'otherSiteState5',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'otherSiteDetails5'
            }
        },

        {
            questionId: '21_supplementalE',
            name: 'otherSiteZipcode5',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Zipcode',
            attributes: {
                controlGroup: 'otherSiteDetails5'
            }
        },

        {
            questionId: '22_supplemental1',
            name: 'otherSubcontractors',
            text: 'Please provide details on number of contractors, trades and scope of work. ',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false
        },
    ]
};

export default ocpData;
